export default __webpack_public_path__ + "static/media/donatewavetop.2e4c5b29.png";